import styled from 'styled-components';

const StudentBody = styled.div`
  margin-top: 7.5em;
  h1 {
    color: ${(p) => p.theme.textPrimary} !important;
    font-size: 2em;
    font-weight: 500;
    margin-bottom: 1.5em;
  }
  ol {
    list-style-type: none;
    margin: 0;
    margin-left: 3em;
    padding: 0;
    counter-reset: li-counter;

    & > li {
      position: relative;
      margin-top: 1rem;
      margin-bottom: 2.5rem;
      padding-left: 0.5em;
      line-height: 1.8em;
      font-size: 1.5em;

      &:before {
        position: absolute;
        top: 0.2em;
        left: -1.33em;
        width: 1.2em;
        height: 1.2em;
        font-size: 1.2em;
        line-height: 1.2;
        text-align: center;
        color: ${(p) => p.theme.textPrimary} !important;
        border: 0;
        border-radius: 50%;
        background-color: ${(p) => p.theme.statePrimaryBg} !important;
        content: counter(li-counter);
        counter-increment: li-counter;
      }
    }
  }
`;

export default StudentBody;
